import { render, staticRenderFns } from "./GeneralTabCardsSection.vue?vue&type=template&id=6be7b277&scoped=true&"
import script from "./GeneralTabCardsSection.vue?vue&type=script&lang=js&"
export * from "./GeneralTabCardsSection.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTabCardsSection.vue?vue&type=style&index=0&id=6be7b277&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be7b277",
  null
  
)

export default component.exports